import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectTypeIconsFetchedPayload = LabeledValuePayload[];

export type SubjectTypeIconsFetchedAction = {
	type: 'SUBJECT_TYPE_ICONS_FETCHED';
	payload: SubjectTypeIconsFetchedPayload;
};

export default (payload: SubjectTypeIconsFetchedPayload): SubjectTypeIconsFetchedAction => ({
	type: 'SUBJECT_TYPE_ICONS_FETCHED',
	payload,
});
